import SourceBadge from './source-badge'
import { HitProps } from '../search/types'
import { cx } from '@/utils/strings'

type SourceLinkProps = {
  className?: string
  hit: HitProps
  size?: 'small' | 'medium'
}

export default function SourceLink({ className, hit, size = 'medium' }: SourceLinkProps) {
  if (size === 'small') {
    return (
      <a
        href={hit.url}
        className={cx(
          'flex items-center text-sm text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors',
          className
        )}
        target="_blank"
        rel="noreferrer noopener"
      >
        <SourceBadge hit={hit} displayType="icon" />
        <span className="line-clamp-1">{hit.title}</span>
      </a>
    )
  }

  return (
    <a
      href={hit.url}
      className={cx(
        'overflow-hidden flex flex-col gap-0.5 rounded px-4 py-3 flex-shrink-0 border border-secondary-100 dark:border-secondary-800 bg-secondary-50 hover:bg-secondary-200 text-bw-deep-blue dark:bg-secondary-700 dark:hover:bg-secondary-600 dark:text-white transition-colors',
        className
      )}
      target="_blank"
      rel="noreferrer noopener"
    >
      <SourceBadge hit={hit} />
      <div className="line-clamp-1 font-medium text-ellipsis text-base">{hit.title}</div>
    </a>
  )
}
